import Keycloak from "keycloak-js";

let keycloak = new Keycloak({
    url: "https://autenticacaodev.cm-abrantes.pt",
    realm: "DSI",
    clientId: "unik"
});

export default keycloak;